<template>
    <div v-if="mode === 'embed' && isOpen" ref="embedElement" class="kakao-postcode" :style="embedStyle"></div>
</template>

<script>
import { loadKakaoPostcodeSdk } from "@/utils/kakaoPostcodeLoader";

export default {
    name: "KakaoPostcode",
    props: {
        mode: {
            type: String,
            default: "popup",
            validator: (value) => ["popup", "embed"].includes(value)
        },
        width: {
            type: [Number, String],
            default: "100%"
        },
        height: {
            type: [Number, String],
            default: 480
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ["complete", "error", "close"],
    data() {
        return {
            kakao: null,
            isOpening: false,
            isOpen: false
        };
    },
    computed: {
        embedStyle() {
            return {
                width: typeof this.width === "number" ? `${this.width}px` : this.width,
                height: typeof this.height === "number" ? `${this.height}px` : this.height
            };
        }
    },
    methods: {
        async open() {
            if (this.isOpening || this.isOpen) {
                return;
            }

            this.isOpening = true;

            try {
                this.kakao = await loadKakaoPostcodeSdk();
                const postcode = new this.kakao.Postcode({
                    ...this.options,
                    oncomplete: this.handleComplete,
                    onclose: this.handleClose
                });

                if (this.mode === "embed") {
                    this.isOpen = true;
                    await this.$nextTick();
                    postcode.embed(this.$refs.embedElement);
                    return;
                }

                this.isOpen = true;
                postcode.open();
            } catch (error) {
                this.isOpen = false;
                this.$emit("error", error);
            } finally {
                this.isOpening = false;
            }
        },
        close() {
            this.isOpen = false;
            this.$emit("close");
        },
        handleComplete(data) {
            const result = this.normalizeResult(data);

            this.isOpen = false;
            this.$emit("complete", result);

            if (this.mode === "embed") {
                this.close();
            }
        },
        handleClose() {
            this.close();
        },
        normalizeResult(data) {
            let address = data.address || "";
            let extraAddress = "";

            if (data.userSelectedType === "R") {
                address = data.roadAddress || address;

                if (data.bname && /[\uB3D9\uB85C\uAC00]$/.test(data.bname)) {
                    extraAddress += data.bname;
                }

                if (data.buildingName && data.apartment === "Y") {
                    extraAddress += extraAddress ? `, ${data.buildingName}` : data.buildingName;
                }

                if (extraAddress) {
                    extraAddress = ` (${extraAddress})`;
                }
            } else {
                address = data.jibunAddress || address;
            }

            return {
                zonecode: data.zonecode,
                address,
                roadAddress: data.roadAddress,
                jibunAddress: data.jibunAddress,
                extraAddress,
                raw: data
            };
        }
    }
};
</script>

<style scoped>
.kakao-postcode {
    overflow: hidden;
}
</style>
